export default __webpack_public_path__ + "static/media/Nergal's Ring of the Eternal Storm.76fca311.jpg";